import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function BancarioSidebar() {
  return <ModuleSidebar config={MODULES.bancario} />;
}
